import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// Supported languages with their native names
export const supportedLanguages = ['en', 'nl', 'de', 'fr', 'es', 'it', 'pt-PT'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const languageNames: Record<SupportedLanguage, string> = {
  en: 'English',
  nl: 'Nederlands',
  de: 'Deutsch',
  fr: 'Français',
  es: 'Español',
  it: 'Italiano',
  'pt-PT': 'Português',
};

// Dropdown order: English first, then alphabetical by native name
export const orderedLanguages: SupportedLanguage[] = [
  'en', // English (always first)
  'de', // Deutsch
  'es', // Español
  'fr', // Français
  'it', // Italiano
  'nl', // Nederlands
  'pt-PT', // Português
];

// Namespace definitions
export const namespaces = [
  'common',
  'auth',
  'issues',
  'projects',
  'tests',
  'documents',
  'golive',
  'time',
  'admin',
  'help',
  'tasks',
  'platform',
] as const;
export type Namespace = (typeof namespaces)[number];

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,

    ns: namespaces,
    defaultNS: 'common',

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'pregoo-language',
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: true,
    },
  });

export default i18n;
